import {
  DEFAULT_POST_LENGTH,
  DEFAULT_POST_STYLES,
} from "../constants/postSettings";

export const FACEBOOK_PROMPT_PROFILE_VERSION = "facebook-post-profile-v2026-04-26";

const normalizeString = (value) => String(value || "").trim();

export const normalizeFacebookPostStyles = (postStyles) => {
  if (Array.isArray(postStyles)) {
    const styles = postStyles.map(normalizeString).filter(Boolean);
    return styles.length > 0 ? styles.join(", ") : DEFAULT_POST_STYLES.join(", ");
  }

  return normalizeString(postStyles) || DEFAULT_POST_STYLES.join(", ");
};

export const buildFacebookAutoPostSettings = ({
  selectedFanpages = [],
  postLength = DEFAULT_POST_LENGTH,
  postStyles = DEFAULT_POST_STYLES,
  customInfo = "",
  includeContactInfo = false,
  useFanpageInfo = false,
  selectedLanguage = "vi",
  postMode = "direct",
  useGrounding = false,
} = {}) => {
  const fanpageCount = Array.isArray(selectedFanpages) ? selectedFanpages.length : 0;

  return {
    postLength: normalizeString(postLength) || DEFAULT_POST_LENGTH,
    postStyles: normalizeFacebookPostStyles(postStyles),
    customInfo: normalizeString(customInfo),
    includeContactInfo: includeContactInfo === true,
    useFanpageInfo: fanpageCount >= 2 ? false : useFanpageInfo === true,
    selectedLanguage: normalizeString(selectedLanguage) || "vi",
    postMode: normalizeString(postMode) || "direct",
    useGrounding: useGrounding === true, // Premium Grounding opt-in, default OFF
    promptProfileVersion: FACEBOOK_PROMPT_PROFILE_VERSION,
  };
};
